var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.editor)?_c('BubbleMenu',{attrs:{"editor":_vm.editor}},[_c('v-btn-toggle',{attrs:{"dense":"","multiple":"","dark":""}},[_c('v-btn',{on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleHeading({ level: 1 })
            .run()}}},[_vm._v(" H1 ")]),_c('v-btn',{on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleHeading({ level: 2 })
            .run()}}},[_vm._v(" H2 ")]),_c('v-btn',{on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleHeading({ level: 3 })
            .run()}}},[_vm._v(" H3 ")]),_c('v-btn',{on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleBold()
            .run()}}},[_c('v-icon',[_vm._v("format_bold")])],1),_c('v-btn',{on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleItalic()
            .run()}}},[_c('v-icon',[_vm._v("format_italic")])],1),_c('v-btn',{on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleUnderline()
            .run()}}},[_c('v-icon',[_vm._v("format_underline")])],1),_c('v-btn',{on:{"click":function($event){_vm.editor
            .chain()
            .focus()
            .toggleHighlight()
            .run()}}},[_c('v-icon',[_vm._v("border_color")])],1)],1)],1):_vm._e(),_c('editor-content',{staticClass:"editor-field",attrs:{"editor":_vm.editor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }